import { render, staticRenderFns } from "./QrCodeDetails.vue?vue&type=template&id=991f981a&"
import script from "./QrCodeDetails.vue?vue&type=script&lang=ts&"
export * from "./QrCodeDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports